import React, { useMemo, useState } from "react";
import SectionTitle from "../components/SectionTitle";
import InfoData from "../InfoData";
import ProjectDialog from "../components/ProjectDialog";
import SectionWrapper from "../components/SectionWrapper";
import Card from "../components/Card";
import Chip from "../components/Chip";

const projects = InfoData.projects;

const Project = () => {
    const [dialogInfo, setDialogInfo] = useState(null);

    const ProjectGridItem = ({ gridInfo, isOdd }) => {
        return (
            <div onClick={() => setDialogInfo(gridInfo)} className="flex cursor-pointer">
                <Card classes={`cursor-pointer ${isOdd ? "border-primary text-primary" : "border-secondary text-secondary"}`}>
                    <div className="rounded-t-xl bg-base">
                        <img src={require(`../${gridInfo.cover_img}`)} alt={`More demo for ${gridInfo.name}`} className="m-auto object-contain rounded-t-[0.625rem]"/>
                    </div>
                    <div className={`p-4 border-t-2 border-solid ${isOdd ? 'border-primary' : 'border-secondary'}`}>
                        <div className="text-xl">{gridInfo.name}</div>
                        <div className="flex flex-wrap gap-1 py-2">
                            {
                                gridInfo.skills.map((skill, index) => (
                                    <Chip key={index} label={skill} classes={isOdd ? 'border-primary' : 'border-secondary'}/>
                                ))
                            }
                        </div>
                    </div>
                </Card>
            </div>
        );
    }

    const ProjectGrid = useMemo(() => {
        return (
            <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
                {
                    projects.map((gridInfo, index) => (
                        <ProjectGridItem key={index} gridInfo={gridInfo} isOdd={index % 2 === 0}/>
                    ))
                }
            </div>
        );
    }, []);

    return (
        <SectionWrapper id="projects">
            <SectionTitle title="Projects"/>
            {ProjectGrid}
            <ProjectDialog dialogInfo={dialogInfo} setProjectDialogData={setDialogInfo}/>
        </SectionWrapper>
    );
}

export default Project;